import firebase from 'firebase/app'
import 'firebase/firestore'
import 'firebase/database'
import 'firebase/auth'
import 'firebase/storage'

const firebaseConfig = {
  apiKey: "AIzaSyDjpuvac0yeyt6WbAHdnoS7BTVyM7LjD8U",
  authDomain: "reventsfb-bcbcb.firebaseapp.com",
  databaseURL: "https://reventsfb-bcbcb.firebaseio.com",
  projectId: "reventsfb-bcbcb",
  storageBucket: "reventsfb-bcbcb.appspot.com",
  messagingSenderId: "850830723544",
  appId: "1:850830723544:web:c920ca9dc1098265"
};

  firebase.initializeApp(firebaseConfig);
  firebase.firestore();

  export default firebase;
